module.exports = __webpack_public_path__ + "img/pattern_grey.bb8cbaae.svg";